import { useFetch } from '#app' // 使用 Nuxt 的 useFetch 方法
import { useRuntimeConfig } from '#app' // 用于获取运行时配置
import { useTokenStore } from '~/stores/token.js'

// 使用 useFetch 封装请求方法
async function fetchWithToken(url, options = {}, requiresToken = false, isProduct = false) {
  const config = useRuntimeConfig()
  const baseUrl = isProduct ? config.public.productBase : config.public.apiBase
  const tokenStore = useTokenStore()

  const defaultHeaders = {
    'Content-Type': 'application/json',
  }

  if (requiresToken) {
    const token = tokenStore.token
    if (token) {
      defaultHeaders['Authorization'] = `Bearer ${token}`
    }
  }

  // 解析传入的 URL
  const currentUrl = useRequestURL()
  const currentQuery = currentUrl.searchParams

  // 解析传入的 URL
  const requestUrl = new URL(baseUrl.replace(/\/$/, '') + '/' + url.replace(/^\//, ''))

  // 检查当前页面的 URL 是否包含 clean-cache=1 参数
  if (currentQuery.get('clean-cache') === '1') {
    // 如果存在 clean-cache=1 参数，将其添加到请求的 URL 中
    requestUrl.searchParams.set('clean-cache', '1')
  }
  const mergedOptions = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  }
  // 使用 useFetch 发起请求
  const { data } = await useFetch(requestUrl.toString(), mergedOptions)
  // const { data } = await useFetch(baseUrl + url, mergedOptions)

  return data.value
}

// GET 请求封装
async function fetchGet(url, requiresToken = false, isProduct = false) {
  return await fetchWithToken(
    url,
    {
      method: 'GET',
    },
    requiresToken,
    isProduct,
  )
}

// POST 请求封装
async function fetchPost(url, data, requiresToken = false, isProduct = false) {
  return await fetchWithToken(
    url,
    {
      method: 'POST',
      body: JSON.stringify(data),
    },
    requiresToken,
    isProduct,
  )
}

// PUT 请求封装
async function fetchPut(url, data, requiresToken = false, isProduct = false) {
  return await fetchWithToken(
    url,
    {
      method: 'PUT',
      body: JSON.stringify(data),
    },
    requiresToken,
    isProduct,
  )
}

// DELETE 请求封装
async function fetchDelete(url, data, requiresToken = false, isProduct = false) {
  return await fetchWithToken(
    url,
    {
      method: 'DELETE',
      body: JSON.stringify(data),
    },
    requiresToken,
    isProduct,
  )
}

export { fetchGet, fetchPost, fetchPut, fetchDelete }
